// Reducer state templates for API requests

export const apiState = (state, overrides) => ({
  ...state, // additional state first, so api request override
  status: 'Idle',
  error: false,
  data: null,
  ...overrides, // state defined in model state last, so developer can override or add more
})

export const apiStatePending = (state) => ({
  ...state, // additional state first, so api request override
  status: 'Pending',
  error: false,
})

export const apiStateError = (state, error) => ({
  ...state, // additional state first, so api request override
  status: 'Error',
  error: error,
})

export const apiStateSuccess = (state, data) => ({
  ...state, // additional state first, so api request override
  status: 'Success',
  error: false,
  data: data,
})

export const apiReducers = (resetState) => ({
  // handle state changes with pure functions
  initial: (state, payload) => apiState(state, resetState),
  pending: (state, payload) => apiStatePending(state),
  success: (state, payload) => apiStateSuccess(state, payload),
  error:   (state, payload) => apiStateError(state, payload),
})

export default apiReducers



// WEBPACK FOOTER //
// ./src/redux/plugins/api/api.reducers.js